import type { Timestamp, FieldValue } from 'firebase/firestore'

export type FirestoreTimestamp = Timestamp | FieldValue | null

export interface TimestampFields {
  createdAt: FirestoreTimestamp
  updatedAt: FirestoreTimestamp
}

export function getErrorMessage(err: unknown, fallback = 'An unexpected error occurred'): string {
  if (err instanceof Error) return err.message
  if (typeof err === 'string') return err
  return fallback
}

// Maps Firebase Auth error codes to human copy — no one should ever see "auth/invalid-credential."
export function getAuthErrorMessage(err: unknown, fallback = 'Sign in failed'): string {
  const code = (err as { code?: string } | null)?.code
  switch (code) {
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return 'Invalid email or password'
    case 'auth/too-many-requests':
      return 'Too many attempts. Try again later or reset your password.'
    case 'auth/account-exists-with-different-credential':
      return 'This email is linked to a different sign-in method. Try Google instead.'
    case 'auth/email-already-in-use':
      return 'An account with this email already exists. Try signing in instead.'
    case 'auth/weak-password':
      return 'Password is too weak. Choose a stronger one.'
    case 'auth/invalid-email':
      return 'Enter a valid email address.'
    case 'auth/user-disabled':
      return 'This account has been disabled. Contact support for help.'
    case 'auth/network-request-failed':
      return 'Network error. Check your connection and try again.'
    default:
      return getErrorMessage(err, fallback)
  }
}
